module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-447-retro.4f04b341.jpg";